import React from 'react'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useScreenSize from '@hooks/useScreenSize'

import ReservationsCheckoutCard from '../Card'

export default function Layout({
  children,
  sidebar
}: {
  children: React.ReactNode
  sidebar?: React.ReactNode
}) {
  const isDarkMode = useIsDarkMode()
  const screenSize = useScreenSize()

  if (!sidebar) {
    return (
      <div
        className={classnames('min-h-screen flex items-center justify-center', {
          ['bg-gray-100 text-black']: !isDarkMode,
          ['bg-gray-900 text-white']: isDarkMode
        })}>
        <div className="max-w-lg mx-auto flex-1 my-10">
          <ReservationsCheckoutCard>{children}</ReservationsCheckoutCard>
        </div>
      </div>
    )
  }

  return (
    <div
      className={classnames('md:flex md:overflow-hidden md:h-screen', {
        ['bg-gray-100 text-black']: !isDarkMode,
        ['bg-gray-900 text-white']: isDarkMode
      })}>
      <div className="overflow-auto flex-1 md:p-10 xl:p-20">{children}</div>
      <div
        className={classnames({
          'overflow-auto flex flex-col mt-4 md:mt-0 md:inset-y-0 md:w-[390px] lg:w-[490px] xl:w-[650px] md:right-0 md:p-10 xl:p-20':
            true,
          'md:bg-white': !isDarkMode,
          'md:bg-gray-800': isDarkMode
        })}>
        {['mobile', 'sm'].includes(screenSize) ? (
          <ReservationsCheckoutCard>{sidebar}</ReservationsCheckoutCard>
        ) : (
          sidebar
        )}
      </div>
    </div>
  )
}
